import type { LocalizedStatus } from '@common/types'
import { StatusType } from '@common/types'
import { TicketStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const ticketStatusMessages = defineMessages({
  closed: {
    defaultMessage: 'Closed',
    description: 'ticket status title',
  },
  open: {
    defaultMessage: 'Open',
    description: 'ticket status title',
  },
  preprocessing: {
    defaultMessage: 'Preprocessing',
    description: 'ticket status title',
  },
})

export function localizeTicketStatus(
  intl: IntlShape,
  status: TicketStatus,
  closeReason: {
    name: string
    success: boolean
  } | null,
): LocalizedStatus {
  switch (status) {
    case TicketStatus.PREPROCESSING:
      return {
        localized: intl.formatMessage(ticketStatusMessages.preprocessing),
        status: StatusType.WARNING,
      }
    case TicketStatus.OPEN:
      return {
        localized: intl.formatMessage(ticketStatusMessages.open),
        status: StatusType.INFO,
      }
    case TicketStatus.CLOSED:
      if (closeReason) {
        return {
          localized: closeReason.name,
          status: closeReason.success ? StatusType.SUCCESS : StatusType.ERROR,
        }
      }

      return {
        localized: intl.formatMessage(ticketStatusMessages.closed),
        status: StatusType.SUCCESS,
      }
  }
}
